<!--
  PlanFeeTerms -- the in-app list of a plan's fee structure.

  Design docs/planning/flat-fee-and-allowance-billing-2026-10-20.md 2.7 and
  4.5. Cards: "#384: Billing: price plan tiers with any combination of flat,
  active, dormant, custom-rate and included-store fees"
  (https://trello.com/c/5wMcO5Bg) and "Per-store subscription billing"
  (https://trello.com/c/WJxkNmTo).

  Presents `fee_terms` as the server sent it: the items of the one renderer
  (`fee_terms.describe_terms`, the same text the trial reminder email and the
  signup page state). It never computes or formats a figure, and never shows
  the "After your trial" sentence: an active plan is not in its trial. Used by
  the Payments plan card and the store billing card, each with its own testid.
  Renders nothing when there is no clear pinned fee to state.
-->
<template>
  <div v-if="items.length" class="tf-fee-terms" :data-testid="testid">
    <div class="tf-fee-terms-title">Your plan's fees</div>
    <ul class="tf-fee-terms-list">
      <li
        v-for="(item, i) in items"
        :key="i"
        data-testid="plan-fee-terms-item"
      >{{ item }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PlanFeeTerms",

  props: {
    // `{sentence, items, list_text, shape}` from the API, or null.
    feeTerms: { type: Object, default: null },
    testid: { type: String, default: "plan-fee-terms" },
  },

  computed: {
    items() {
      const items = this.feeTerms && this.feeTerms.items;
      return Array.isArray(items) ? items : [];
    },
  },
};
</script>

<style scoped>
.tf-fee-terms {
  margin-bottom: 14px;
  font-size: 13px;
  color: var(--tf-fg-2, #34424d);
}
.tf-fee-terms-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--tf-fg-4, #8a97a3);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.tf-fee-terms-list {
  margin: 0;
  padding-left: 18px;
  line-height: 1.6;
}
</style>
